import { FormItem } from '../../types/types';
import { getDefaultValueByType } from '../getDefaultValueByType';

// Normalizes a handler response before it merges into the host state:
//  - undefined → field not addressed by the handler; dropped so the current
//    value is left untouched.
//  - null → reset the field to its type default (the same default the submit
//    body uses) instead of writing a raw null.
export const normalizeHandlerFieldUpdates = (
  fieldUpdates: Record<string, unknown>,
  items: FormItem[]
): Record<string, unknown> => {
  const normalized: Record<string, unknown> = {};

  Object.entries(fieldUpdates).forEach(([field, value]) => {
    if (value === undefined) {
      return;
    }

    if (value === null) {
      const item = items.find((formItem) => formItem?.name === field);
      normalized[field] = getDefaultValueByType(item?.type);
      return;
    }

    normalized[field] = value;
  });

  return normalized;
};
